document.addEventListener('gesturestart', function (event) {
  event.preventDefault()
})
